import { useLingui } from '@lingui/react/macro';

import Button from '@/design_system/Button';
import Stack from '@/design_system/Stack';
import IconFile from '@/icons/File.svg';

export const ActivityMediumLink = ({
  medium,
}: {
  medium: {
    reference: string | null;
    url: string;
  };
}) => {
  const { t } = useLingui();

  return (
    <Stack alignItems="flex-start">
      <Button variant="link" size="small" href={medium.url} target="_blank" rel="noreferrer">
        <IconFile />
        {medium.reference ??
          t({ id: 'activities.medium-link.default-label', message: 'View document' })}
      </Button>
    </Stack>
  );
};
